<template>
    
    <div>
        <section class="diabetesBgHero-1 background-hero py-4">
            <section class="flex flex-col justify-center py-4 lg:flex-row lg:justify-between lg:max-w-5xl lg:mx-auto mt-4">
            
                <section
                class="flex flex-col items-center justify-center py-4 lg:flex-row lg:justify-between lg:max-w-7xl lg:mx-auto"
                >
                    <section class="flex-1 px-20 justify-center mb-2 lg:mb-0 md:order-2 order-2 lg:order-1 mt-4">
                        <img src="/image/courses/diabetesTelemedicina/foto_1.webp" class="rounded-full text-center" alt="" />
                    </section>
                    <section class="flex-1 mb-2 lg:mb-0 md:order-1 order-1 lg:order-2 md-center-text">
                        <section class="flex justify-center lg:justify-start">
                            <img src="/image/brand/logo_fondo_obscuro.svg" class="flex content-center lg:content-start"  width="150">
                       </section>
                        <p class="text-white text-4xl font-bold mb-4 mt-5">Gracias por tu registro</p>
                        <p class="text-white">Tu camino para ser un experto en TELEMEDICINA empieza aquí </p>

                        <p class="text-white mt-3">Celebro de todo corazón tu decisión a dar el paso hacia una vida llena de salud al registrarte, entrarás al grupo de telegram para darte los avisos cuando vamos a comenzar, y en el grupo de facebook donde colocaras tus tareas y las revisaremos en vivo.</p>
                    </section>
                    
                </section>


            </section>

            
        </section>
        <footer class="flex justify-center bg-white py-2">
            <p class="text-sm" v-text="'Amoba Software todos los derechos reservados 2022'" />
        </footer>
    </div>

</template>


<script>
    export default {
        mounted(){

            if(sessionStorage.getItem("lead_thanks") != "true"){
                this.$router.push({name: "diabetesTelemedicine"})
            }
        }
    }
</script>


<style scoped>

    .diabetesBgHero-1{
        background-image: url("/image/courses/diabetesTelemedicina/fondo_banner (1).webp");
        background-size: cover;
        background-repeat: no-repeat;
        height: 100vh;
    }
    
    footer{
        margin-top: -37px;
    }

    @media (max-width: 991px){
        .md-center-text {
            text-align: center;
            padding-left: 20%;
            padding-right: 20%;
            margin-bottom: 30px;
        }

        .diabetesBgHero-1{
            height: 100%;
        }
    }

</style>